<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" persistent max-width="400px")
      v-card
        v-card-title(style="height:56px;")
          .h6.basic800--text Upgrade to Paid Version
        v-divider.basic300
        v-card-text.py-3
          .p2.primary400--text As much as you enjoy the FREE version, we are very sorry, your current FREE plan does not allow you to do that. Subscribe now to enjoy this feature.
        v-card-actions
          v-spacer
          v-btn.mr-2(color='white', text @click="showModal = !showModal")
            .button-Aa-small.primary400--text Close
          v-btn(color="textColorAccent" dark small depressed @click="showSubscribeModal = true") 
            .button-AA-small.basic100--text Subscribe now
    .modals
      subscribe-modal(v-if="showSubscribeModal" :open.sync="showSubscribeModal" :company="company" :volunteer="true" @subscribed="fetchContract")
</template>

<script>
import SubscribeModal from '@/components/billing/SubscribeModal.vue'
export default {
  name: 'UpgradeFreeDialog',
  props: ['open'],
  components: { SubscribeModal },
  data: () => ({
    showSubscribeModal: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{}
</i18n>
